import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { RoutingRuleListTableRowData } from '../types';
import { getTargetDescription, getTargetTitle } from '../../../utils/targetBill';
import { RowTextCell } from './RowTextCell';

interface TargetBillCellProps {
    targetBill: RoutingRuleListTableRowData['targetBill'];
}

export const TargetBillCell: React.FC<TargetBillCellProps> = ({ targetBill }) => {
    const granularRoutingRulesConditionsExtensionEnabled = useFeatureFlag(
        FeatureFlag.granularRoutingRulesConditionsExtensionEnabled
    );

    return (
        <RowTextCell
            title={getTargetTitle(targetBill.targetType)}
            description={getTargetDescription({
                assignmentType: targetBill.targetType,
                aggregationType: targetBill.aggregationType,
                granularRoutingRulesConditionsExtensionEnabled,
                compact: true,
            })}
        />
    );
};
